import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const CTA = ({ onClick }) => {
  return (
    <section
      id="contact"
      className="relative py-24 sm:py-32 overflow-hidden"
      data-testid="cta-section"
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 20% 20%, #1d72ff 0%, transparent 45%), radial-gradient(circle at 80% 80%, #1d72ff 0%, transparent 45%), #0a1d4d",
        }}
      />
      <div className="absolute inset-0 lq-grid-bg-dark opacity-40 [mask-image:radial-gradient(circle_at_center,black,transparent_70%)]" />
      <div
        className="lq-orb"
        style={{
          background: "#1d72ff",
          width: 600,
          height: 600,
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          opacity: 0.5,
        }}
      />

      <div className="relative max-w-5xl mx-auto px-5 sm:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/10 border border-white/15 text-white/90 text-xs sm:text-sm font-medium"
        >
          <Sparkles className="w-3.5 h-3.5 text-[#4d8eff]" /> Free 20-min
          strategy call
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display font-extrabold text-4xl sm:text-5xl lg:text-7xl text-white mt-6 leading-[1.02]"
          data-testid="cta-heading"
        >
          Ready to grow?
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-6 text-base sm:text-lg text-white/75 max-w-2xl mx-auto leading-relaxed"
        >
          Tell us about your brand. We’ll send back a custom content plan
          with hook ideas, an editing roadmap and a 90-day growth target.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-10 flex flex-col sm:flex-row gap-3 justify-center"
        >
          <Button
            onClick={onClick}
            size="lg"
            className="h-13 rounded-full bg-white hover:bg-[#1d72ff] hover:text-white text-[#0a1d4d] font-semibold px-8 transition-colors group"
            data-testid="cta-primary-button"
          >
            Book a Free Call
            <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Button>
          <Button
            onClick={onClick}
            variant="outline"
            size="lg"
            className="h-13 rounded-full border-2 border-white/25 text-white hover:bg-white hover:text-[#0a1d4d] font-semibold px-8 bg-transparent transition-colors"
            data-testid="cta-secondary-button"
          >
            Send us a brief
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
